<template>
  <div id="scheduleTools" class="row">
    <h1>test</h1>
    <p>{{getStore('pups')}}</p>
    <data-loader
      target="pups"
      load-src="pup/getlist"
      extra-params="limit=0,sort=name"
      model-type="array"
    >
    
    </data-loader>
    <data-loader
      target="vehicles"
      load-src="assets/getlist"
      extra-params="limit=0"
      model-type="array"
    ></data-loader>
    <!-- <data-loader target="sappliers" load-src="sappliers/getlist" extra-params="limit=0" model-type="array"></data-loader> -->
    <data-loader
      target="tourco"
      load-src="sappliers/getlist"
      extra-params="limit=0"
      model-type="array"
    ></data-loader>
    <data-loader
      target="resorts"
      load-src="locations/getlist"
      extra-params="limit=0,sort=name"
      model-type="array"
    ></data-loader>
  </div>
</template>

<script>
import * as api from "~/api/resource";
import * as sGrid from "~/api/slickGrids";
import { mapGetters, mapActions } from "vuex";
import { async } from "q";
export default {
  async mounted() {},
  watch: {},
  methods: {},
  // data() {},
  computed: {
    ...mapGetters({
      getStore: "helpers/getStore"
    })
  }
};
</script>